import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.delays.index']) {
    return await api(route('api.v1.delays.index', projectId), 'get', {
      data,
      casts: {
        next_action_assignee_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        search: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        status: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.delays.show', id), 'get');
  },

  async accept(id: Id) {
    return await api(route('api.v1.delays.accept', id), 'post');
  },

  async decline(id: Id) {
    return await api(route('api.v1.delays.decline', id), 'post');
  },

  async submit(id: Id, data: ApiRequests['api.v1.delays.submit']) {
    return await api(route('api.v1.delays.submit', id), 'post', {
      data,
      casts: {
        description: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.delays.destroy', id), 'delete');
  },

  async provision(id: Id, signedParams: unknown) {
    return await apiConfig(route('api.v1.delays.provision', id), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    });
  },

  async declineSubmission(id: Id, signedParams: unknown, data: ApiRequests['api.v1.delays.decline-submission']) {
    return await apiConfig(route('api.v1.delays.decline-submission', id), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
    });
  },

  async approve(id: Id, data: ApiRequests['api.v1.delays.approve']) {
    return await api(route('api.v1.delays.approve', id), 'post', {
      data,
    });
  },

  async complete(id: Id) {
    return await api(route('api.v1.delays.complete', id), 'post');
  },

  async create(projectId: Id, data: ApiRequests['api.v1.delays.store'] | FormData) {
    return await api(route('api.v1.delays.store', projectId), 'post', {
      data,
      casts: {
        notes: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        start_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        end_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.delays.update']) {
    return await api(route('api.v1.delays.update', id), 'patch', {
      data,
      casts: {
        notes: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        client_ref: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        start_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        end_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },
  // async delete(id: Id) {
  //   return await api(route('api.v1.delays.destroy', id), 'delete');
  // },

  async nextAction(id: Id, data: ApiRequests['api.v1.delays.next-action']) {
    return await api(route('api.v1.delays.next-action', id), 'patch', {
      data,
      casts: {
        next_action: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        next_action_assignee_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        next_action_due_date: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async summary(projectid: Id) {
    return await api(route('api.v1.delays.summary', projectid), 'get');
  },

  async comment(id: Id, data: ApiRequests['api.v1.delays.comments']) {
    return await api(route('api.v1.delays.comments', id), 'post', {
      data,
    });
  },

  async attachVariationOrder(id: Id, data: ApiRequests['api.v1.delays.attach-variation-order']) {
    return await api(route('api.v1.delays.attach-variation-order', id), 'post', {
      data,
      casts: {
        notes: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async media(id: Id) {
    return await api(route('api.v1.delays.media.show', id), 'get');
  },

  async storeMedia(id: Id, data: ApiRequests['api.v1.delays.media.store'] | FormData) {
    return await api(route('api.v1.delays.media.store', id), 'post', {
      data,
    });
  },

  async sendNotice(id: Id, data: ApiRequests['api.v1.delays.send-notice']) {
    return await api(route('api.v1.delays.send-notice', id), 'post', {
      data,
      casts: {
        description: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  notice: {
    async store(id: Id, data: ApiRequests['api.v1.delays.notice.store'] | FormData) {
      return await api(route('api.v1.delays.notice.store', id), 'post', {
        data,
      });
    },
  },

  valueNotice: {
    async store(id: Id, data: ApiRequests['api.v1.delays.value-notice.store'] | FormData) {
      return await api(route('api.v1.delays.value-notice.store', id), 'post', {
        data,
      });
    },
  },

  correspondence: {
    async index(id: Id) {
      return await api(route('api.v1.delays.correspondence.index', id), 'get');
    },

    async store(id: Id, data: ApiRequests['api.v1.delays.correspondence.store'] | FormData) {
      return await api(route('api.v1.delays.correspondence.store', id), 'post', {
        data,
      });
    },
  },
};
